/* Native swipe rails with keyboard and button navigation, scoped to the second edit. */
(() => {
  const mount = root => {
    if (document.querySelector('#holiday-second-edit')) {
      root.querySelectorAll('.lig-cl-product-grid,.lig-best-sellers__grid').forEach((track, index) => {
        if (track.dataset.lvProductReady || !track.firstElementChild) return;
        track.dataset.lvProductReady = 'true';
        const heading = track.closest('section,.lig-best-sellers')?.querySelector('h2');
        const label = heading?.textContent.trim() || 'Featured garments';
        track.id ||= `lv-products-${track.closest('[id]')?.id || index}`;
        track.tabIndex = 0;
        track.setAttribute('role','region');
        track.setAttribute('aria-label',`${label} product photographs`);
        const nav = document.createElement('div');
        nav.className = 'lv-product-nav';
        const status = document.createElement('span');
        const buttons = document.createElement('div');
        buttons.className = 'lv-product-nav__buttons';
        const makeButton = (direction, text) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.textContent = text;
          button.setAttribute('aria-label',`${direction < 0 ? 'Previous' : 'Next'} ${label} product`);
          button.setAttribute('aria-controls',track.id);
          button.addEventListener('click',() => move(direction));
          buttons.append(button);
          return button;
        };
        const distance = () => track.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap);
        const move = direction => track.scrollBy({left:direction * distance(),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        const previous = makeButton(-1,'←');
        const next = makeButton(1,'→');
        const update = () => {
          previous.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
          status.textContent = `Swipe to explore · ${Math.min(track.children.length,Math.round(track.scrollLeft / distance()) + 1)} / ${track.children.length}`;
        };
        nav.append(status,buttons);
        track.after(nav);
        track.addEventListener('scroll',update,{passive:true});
        track.addEventListener('keydown',event => {
          if (event.target !== track || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
          event.preventDefault();move(event.key === 'ArrowRight' ? 1 : -1);
        });
        new ResizeObserver(update).observe(track);
        update();
      });
    }
    root.querySelectorAll('[data-lv-rail],[data-lv-more]').forEach(rail => {
      if (rail.dataset.lvReady) return;
      rail.dataset.lvReady = 'true';
      const track = rail.querySelector('.lv-rail__track,.lv-more__track');
      if (!track || !track.firstElementChild) return;
      const previous = rail.querySelector('[data-lv-prev]');
      const next = rail.querySelector('[data-lv-next]');
      const update = () => {
        const extent = track.scrollWidth - track.clientWidth;
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= extent - 2;
        rail.classList.toggle('lv-rail--static', extent <= 2);
      };
      const move = direction => {
        const card = track.firstElementChild;
        if (!card) return;
        const distance = card.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).gap) || 0);
        track.scrollBy({ left: direction * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, { passive: true });
      track.addEventListener('keydown', event => {
        if (event.target !== track || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
      });
      new ResizeObserver(update).observe(track);
      update();
    });
  };
  if (!window.__ligHolidayV2) {
    window.__ligHolidayV2 = true;
    document.addEventListener('shopify:section:load', event => mount(event.target));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(document), { once: true });
  else mount(document);
})();
